function SkeletonLine({ className = "" }) {
  return <div className={`bg-slate-200 rounded animate-pulse ${className}`} />;
}

export function DashboardSkeleton() {
  return (
    <div className="grid gap-4 sm:grid-cols-2 lg:grid-cols-3">
      {[1, 2, 3].map(i => (
        <div key={i} className="bg-white rounded-xl border border-slate-200 p-5">
          <div className="flex items-start justify-between mb-3">
            <SkeletonLine className="h-5 w-20" />
            <SkeletonLine className="h-4 w-16" />
          </div>
          <SkeletonLine className="h-5 w-3/4 mb-2" />
          <SkeletonLine className="h-3 w-1/2 mb-4" />
          <SkeletonLine className="h-2 w-full mb-2" />
          <SkeletonLine className="h-3 w-1/3" />
        </div>
      ))}
    </div>
  );
}

export function AttachmentsSkeleton() {
  return (
    <div className="grid grid-cols-3 sm:grid-cols-4 gap-2">
      {[1, 2, 3].map(i => (
        <SkeletonLine key={i} className="h-20 rounded-lg" />
      ))}
    </div>
  );
}
